/**
 * Handles decoding of obfuscated links (e.g. mailto: and tel:)
 * to prevent scraping.
 * 
 * @param {HTMLElement|Document} container - The container to search for links within.
 */
export function initializeObfuscatedLinks(container = document) {
    const links = container.querySelectorAll('a[data-reveal="1"]');

    links.forEach(link => {
        // Avoid double binding if this function is called multiple times on the same element
        if (link.dataset.obfuscatedInitialized) return;
        link.dataset.obfuscatedInitialized = 'true';

        const reveal = () => {
            // If the link is already revealed (href is not # or empty), do nothing
            if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '') return;

            const encoded = link.dataset.href;
            const type = link.dataset.type;

            if (encoded && type) {
                try {
                    const decoded = atob(encoded);
                    let prefix = '';

                    if (type === 'tel') {
                        prefix = 'tel:';
                    } else if (type === 'mailto') {
                        prefix = 'mailto:';
                    }

                    link.href = prefix + decoded;
                } catch (e) {
                    console.error('Error decoding obfuscated link', e);
                }
            }
        };

        // Reveal on hover or focus so the user sees the URL in the status bar
        link.addEventListener('mouseenter', reveal);
        link.addEventListener('focus', reveal);
        link.addEventListener('touchstart', reveal, { passive: true });

        // Reveal on click (fallback if hover didn't happen)
        link.addEventListener('click', (e) => {
            if (link.getAttribute('href') === '#' || link.getAttribute('href') === '') {
                e.preventDefault();
                reveal();
                // If successfully revealed, navigate immediately
                if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '') {
                    window.location.href = link.href;
                }
            }
        });
    });
}
